module.exports = __webpack_public_path__ + "img/robot.63b0cd70.png";